/* ============================================================
   POVA commerce — cart drawer, variants, theme + audio persistence, SFX
   ============================================================ */
(function () {
  "use strict";
  var I18N = window.POVA_I18N || {};
  function T(k, d) { return (I18N[k] != null) ? I18N[k] : d; }
  var FREE_SHIP_THRESHOLD = 199900; // paise (₹1,999) — phones always clear it
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- P4 motion helpers ----------------
     Honour prefers-reduced-motion for every choreographed beat, and a
     restart-animation helper (remove class → force reflow → re-add) so a
     one-shot CSS animation can replay on the same element. */
  function prefersReduced() {
    try { return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); }
    catch (e) { return false; }
  }
  function retrigger(node, cls) {
    if (!node) return;
    node.classList.remove(cls);
    void node.offsetWidth; // force reflow so the animation restarts
    node.classList.add(cls);
  }

  var inr = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });
  function money(paise) { return inr.format((paise || 0) / 100); }

  /* ---------------- SFX (extensible) ---------------- */
  var SFX = (function () {
    var ctx = null;
    function on() { try { return localStorage.getItem("pova-audio") === "on"; } catch (e) { return false; } }
    function tone(freq, dur, type, gain) {
      if (!on()) return;
      try {
        ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
        var o = ctx.createOscillator(), g = ctx.createGain();
        o.type = type || "sine"; o.frequency.value = freq;
        g.gain.value = gain || 0.04;
        o.connect(g); g.connect(ctx.destination);
        o.start(); g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + (dur || 0.12));
        o.stop(ctx.currentTime + (dur || 0.12));
      } catch (e) {}
    }
    // add more named cues here anytime
    var lib = {
      tick: function () { tone(660, 0.05, "square", 0.025); },
      add:  function () { tone(523, 0.09, "sine", 0.05); setTimeout(function () { tone(784, 0.12, "sine", 0.05); }, 70); },
      open: function () { tone(440, 0.08, "sine", 0.04); },
      toggle: function () { tone(587, 0.07, "triangle", 0.04); }
    };
    return { play: function (n) { (lib[n] || function () {})(); }, add: function (n, fn) { lib[n] = fn; } };
  })();
  window.POVA = window.POVA || {}; window.POVA.sfx = SFX;

  /* ---------------- Theme + audio toggles (persist site-wide) ---------------- */
  function applyTheme(t) { document.body.setAttribute("data-theme", t); document.documentElement.setAttribute("data-user-theme", t); }
  function currentTheme() { return document.body.getAttribute("data-theme") || "black"; }
  $$("[data-theme-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var next = currentTheme() === "black" ? "white" : "black";
      try { localStorage.setItem("pova-theme", next); } catch (e) {}
      applyTheme(next); SFX.play("toggle");
    });
  });
  function applyAudio(a) { document.documentElement.setAttribute("data-audio", a); document.body && document.body.setAttribute("data-audio", a); }
  (function () { try { applyAudio(localStorage.getItem("pova-audio") || "off"); } catch (e) {} })();
  $$("[data-audio-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var cur = (function () { try { return localStorage.getItem("pova-audio") || "off"; } catch (e) { return "off"; } })();
      var next = cur === "on" ? "off" : "on";
      try { localStorage.setItem("pova-audio", next); } catch (e) {}
      applyAudio(next); if (next === "on") SFX.play("toggle");
    });
  });

  /* ---------------- Cart ---------------- */
  function getCart() { return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }); }

  // 120px line-item thumbnail. Same Shopify size transform the drawer has
  // always used, kept identical so the rendered image is byte-for-byte the
  // same — only lifted out of the render string into a named helper.
  function thumb(url) { return url ? url.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : ""; }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // Build one cart line as real DOM. Emits the exact same structure and
  // classes as the previous innerHTML string, but product/variant titles go
  // in via textContent, so a title containing markup can no longer inject
  // HTML into the drawer.
  function buildLine(it) {
    var line = el("div", "cx-line");
    line.setAttribute("data-line-key", it.key);

    var img = el("img", "cx-line__img");
    img.src = thumb(it.image); img.alt = "";
    line.appendChild(img);

    var mid = el("div");
    mid.appendChild(el("div", "cx-line__title", it.product_title));
    mid.appendChild(el("div", "cx-line__variant", it.variant_title || ""));

    var qty = el("div", "cx-qty");
    var minus = el("button", null, "−");
    minus.type = "button"; minus.setAttribute("data-qty-minus", ""); minus.setAttribute("aria-label", T('qty_decrease', 'Decrease'));
    var count = el("span", null, String(it.quantity));
    var plus = el("button", null, "+");
    plus.type = "button"; plus.setAttribute("data-qty-plus", ""); plus.setAttribute("aria-label", T('qty_increase', 'Increase'));
    qty.appendChild(minus); qty.appendChild(count); qty.appendChild(plus);
    mid.appendChild(qty);
    line.appendChild(mid);

    var right = el("div");
    right.appendChild(el("div", "cx-line__price", money(it.final_line_price)));
    var remove = el("button", "cx-line__remove", T('remove', 'Remove'));
    remove.type = "button"; remove.setAttribute("data-line-remove", "");
    right.appendChild(remove);
    line.appendChild(right);

    return line;
  }

  function renderDrawer(cart) {
    $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
    var inline = $("[data-cart-count-inline]"); if (inline) inline.textContent = "(" + cart.item_count + ")";
    var wrap = $("[data-cart-items]"), empty = $("[data-cart-empty]"), foot = $("[data-cart-foot]"), ship = $("[data-ship-wrap]");
    if (!wrap) return;
    if (cart.item_count === 0) {
      wrap.innerHTML = ""; if (empty) empty.hidden = false; if (foot) foot.style.display = "none"; if (ship) ship.style.display = "none";
      return;
    }
    if (empty) empty.hidden = true; if (foot) foot.style.display = ""; if (ship) ship.style.display = "";
    wrap.textContent = "";
    cart.items.forEach(function (it, idx) {
      var ln = buildLine(it);
      ln.style.setProperty("--cx-i", idx); // drives the P4 line-item stagger on open
      wrap.appendChild(ln);
    });
    var sub = $("[data-cart-subtotal]"); if (sub) sub.textContent = money(cart.total_price);
    // free-ship bar
    var msg = $("[data-ship-msg]"), fill = $("[data-ship-fill]");
    if (msg && fill) {
      // Progress ratio 0..1 (threshold logic unchanged). The fill is rendered
      // with transform:scaleX(var(--cx-ship)) in CSS (transform guardrail), not
      // width; openDrawer resets it to 0 and animates to this target on open.
      var ratio = cart.total_price >= FREE_SHIP_THRESHOLD ? 1 : (cart.total_price / FREE_SHIP_THRESHOLD);
      if (ratio > 1) ratio = 1;
      if (cart.total_price >= FREE_SHIP_THRESHOLD) { msg.innerHTML = "<b>" + T('ship_unlocked_a','Free shipping unlocked') + "</b>" + T('ship_unlocked_b'," — dispatch in 24–48h."); }
      else { msg.innerHTML = T('ship_add_a','Add ') + "<b>" + money(FREE_SHIP_THRESHOLD - cart.total_price) + "</b>" + T('ship_add_b'," for free shipping."); }
      fill.setAttribute("data-ship", ratio);
      fill.style.setProperty("--cx-ship", ratio);
    }
  }

  function refresh() { return getCart().then(renderDrawer); }

  // aria-live region for state changes that have no visible text change of
  // their own on the trigger element (e.g. a confirmation announced while
  // the drawer itself is still animating open). Lives in cart-drawer.liquid.
  function announce(msg) { var live = $("[data-cart-live]"); if (live) live.textContent = msg || ""; }

  // Focus trap (WCAG 2.1 §2.4.3 dialog pattern) — mirrors the proven trapTab() in
  // js-xp-story.js. While the cart drawer is open, Tab from the last focusable
  // element wraps to the first and Shift+Tab from the first wraps to the last, so
  // keyboard focus can never leave the drawer into the page behind it. Focus-in on
  // open, focus-return on close and Escape are already handled below.
  function drawerFocusable(d) {
    var nodes = d.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function (el) { return !el.disabled && el.offsetParent !== null; });
  }
  function trapDrawerTab(d, e) {
    var f = drawerFocusable(d);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first || !d.contains(document.activeElement)) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last || !d.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
  }

  // Focus management (WCAG 2.1 §2.4.3 / dialog pattern): remember what had
  // focus before the drawer opened, move focus INTO the dialog on open
  // (the close button is the first interactive element), and restore focus
  // to the trigger on close — whatever closed it (close button, scrim click,
  // or Escape).
  var cartLastFocus = null;
  function openDrawer() {
    var s = $("[data-cart-scrim]"), d = $("[data-cart-drawer]");
    cartLastFocus = document.activeElement;
    if (s) s.classList.add("is-open");
    if (d) {
      d.classList.add("is-open");
      d.setAttribute("aria-hidden", "false");
      // P4 — on open only (not on qty re-renders): stagger the line-items in
      // and play the free-shipping fill 0→value reward beat. Skipped entirely
      // under reduced-motion (drawer just opacity-fades, bar at final width).
      if (!prefersReduced()) {
        retrigger(d, "cx-opening");
        setTimeout(function () { d.classList.remove("cx-opening"); }, 1200);
        var fill = $("[data-ship-fill]", d);
        if (fill) {
          var target = fill.getAttribute("data-ship") || "0";
          fill.style.setProperty("--cx-ship", "0");
          void fill.offsetWidth; // reflow so the transition runs from 0
          requestAnimationFrame(function () { fill.style.setProperty("--cx-ship", target); });
        }
      }
      var closeBtn = $("[data-cart-close]", d);
      if (closeBtn) closeBtn.focus();
    }
    SFX.play("open");
  }
  function closeDrawer() {
    var s = $("[data-cart-scrim]"), d = $("[data-cart-drawer]");
    if (s) s.classList.remove("is-open");
    if (d) { d.classList.remove("is-open"); d.setAttribute("aria-hidden", "true"); }
    if (cartLastFocus && cartLastFocus.focus) cartLastFocus.focus();
    cartLastFocus = null;
  }

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-cart-open]"), closeBtn = e.target.closest("[data-cart-close]"),
        scrim = e.target.closest("[data-cart-scrim]"), legacyCart = e.target.closest('a[href="#cart"], a[href$="shop#cart"], .nav-pill .cart');
    if (openBtn || legacyCart) { e.preventDefault(); refresh().then(openDrawer); }
    if (closeBtn || scrim) { closeDrawer(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeDrawer(); return; }
    if (e.key === "Tab") { var d = $("[data-cart-drawer]"); if (d && d.classList.contains("is-open")) trapDrawerTab(d, e); }
  });

  function addToCart(id, qty) {
    return fetch("/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }] })
    }).then(function (r) {
      /* Shopify returns HTTP 422 with a JSON error body when an item can't be
       * added (sold out, inventory limit, variant unavailable). fetch does NOT
       * reject on 4xx, so we must check r.ok — otherwise a failed add still
       * resolves and the button falsely shows "Added ✓". */
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error((data && data.description) || "Could not add to cart");
          err.cartError = data; err.soldOut = r.status === 422;
          throw err;
        }
        return data;
      });
    });
  }
  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // Add-to-cart buttons (PDP + sticky)
  $$("[data-add-to-cart]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = btn.getAttribute("data-variant-id"); if (!id) return;
      btn.disabled = true; var label = btn.textContent; btn.textContent = T('adding','Adding…');
      addToCart(id, 1).then(function () { return refresh(); }).then(function () {
        SFX.play("add"); if (!prefersReduced()) retrigger(btn, "cx-pulse"); // P4 confirm pulse
        openDrawer(); var added = T('added','Added ✓'); btn.textContent = added; announce(added);
        setTimeout(function () { btn.textContent = label; btn.disabled = false; announce(""); }, 1200);
      }).catch(function (err) {
        var msg = (err && err.soldOut) ? T('sold_out','Sold out') : T('try_again','Try again');
        btn.textContent = msg; btn.disabled = false; announce(msg);
        setTimeout(function () { btn.textContent = label; announce(""); }, 1800);
      });
    });
  });

  // P4 — CTA press state: scale the Add-to-Bag CTA to 0.97 on pointerdown,
  // release on pointerup/cancel. Delegated so it also covers the sticky CTA.
  // Skipped under reduced-motion. A global release sweep guarantees no button
  // is ever left stuck in the pressed state.
  function clearPressing() { $$("[data-add-to-cart].is-pressing").forEach(function (b) { b.classList.remove("is-pressing"); }); }
  document.addEventListener("pointerdown", function (e) {
    var b = e.target.closest("[data-add-to-cart]");
    if (!b || b.disabled || prefersReduced()) return;
    b.classList.add("is-pressing");
  });
  document.addEventListener("pointerup", clearPressing);
  document.addEventListener("pointercancel", clearPressing);

  // P4 — qty stepper feedback: a light rise+fade swap of the subtotal number.
  function bumpSubtotal() { if (prefersReduced()) return; retrigger($("[data-cart-subtotal]"), "cx-rolled"); }

  // Drawer qty / remove (delegated)
  document.addEventListener("click", function (e) {
    var line = e.target.closest("[data-line-key]"); if (!line) return;
    var key = line.getAttribute("data-line-key");
    var qtyEl = line.querySelector(".cx-qty span, [data-qty-val]");
    var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest("[data-qty-plus]") || e.target.closest("[data-qty-minus]")) {
      SFX.play("tick");
      var isPlus = !!e.target.closest("[data-qty-plus]");
      var newQty = isPlus ? cur + 1 : Math.max(0, cur - 1);
      changeLine(key, newQty).then(function (c) {
        renderDrawer(c);
        /* 2.4.3/2.4.7: renderDrawer rebuilds the drawer line DOM, destroying the +/- button
           that had focus -> focus fell to <body>. Restore focus to the same control on the
           re-rendered line (or, if the line is gone at qty 0, the drawer close button). */
        var dEl = $("[data-cart-drawer]");
        if (dEl && dEl.classList.contains("is-open")) {
          var nl = dEl.querySelector('[data-line-key="' + key + '"]');
          if (nl) { var tgt = nl.querySelector(isPlus ? "[data-qty-plus]" : "[data-qty-minus]") || nl.querySelector("[data-line-remove]"); if (tgt && tgt.focus) tgt.focus(); }
          else { var cb = $("[data-cart-close]", dEl); if (cb && cb.focus) cb.focus(); }
        }
        /* On the /cart page the rows are server-rendered (not the drawer node
         * renderDrawer touches), so update this row's qty + line price + the
         * subtotal in place. Previously the +/- changed the cart server-side
         * but nothing on the page moved, so it looked broken. */
        if (window.location.pathname === "/cart") {
          if (newQty === 0) {
            if (line && line.parentNode) line.parentNode.removeChild(line);
            if (c.item_count === 0) { window.location.reload(); return; }
          } else {
            var item = null;
            for (var i = 0; i < c.items.length; i++) { if (c.items[i].key === key) { item = c.items[i]; break; } }
            if (item) {
              var qv = line.querySelector("[data-qty-val], .cx-qty span"); if (qv) qv.textContent = item.quantity;
              var lp = line.querySelector(".cx-line__price, [data-line-price]"); if (lp) lp.textContent = money(item.final_line_price);
            }
          }
          var sub = $("[data-cart-subtotal]"); if (sub) sub.textContent = money(c.total_price);
        }
        bumpSubtotal(); // P4 qty-stepper subtotal feedback
        /* M3 (WCAG 4.1.3 Status Messages): announce the qty/subtotal change, which
           otherwise updates silently, via the existing cart live region. */
        if (newQty === 0) announce(T('cart_removed', 'Item removed') + '. ' + T('subtotal', 'Subtotal') + ' ' + money(c.total_price));
        else announce(T('qty_label', 'Quantity') + ' ' + newQty + '. ' + T('subtotal', 'Subtotal') + ' ' + money(c.total_price));
      });
    }
    else if (e.target.closest("[data-line-remove]")) {
      changeLine(key, 0).then(function (c) {
        renderDrawer(c);
        /* M3 (WCAG 4.1.3): announce the removal + new subtotal. */
        announce(T('cart_removed', 'Item removed') + '. ' + T('subtotal', 'Subtotal') + ' ' + money(c.total_price));
        // On the /cart page, update the row in place instead of a full reload:
        // remove the line node and refresh the visible subtotal. Only fall back
        // to a reload when the cart becomes empty (to show the server-rendered
        // empty state), so the common case no longer flashes the whole page.
        if (window.location.pathname === "/cart") {
          if (line && line.parentNode) line.parentNode.removeChild(line);
          var sub = $("[data-cart-subtotal]"); if (sub) sub.textContent = money(c.total_price);
          if (c.item_count === 0) window.location.reload();
        }
      });
    }
  });

  /* ---------------- PDP variant selection ---------------- */
  var buy = $("[data-product-json]");
  if (buy) {
    var variants = [];
    try { variants = JSON.parse(buy.getAttribute("data-product-json").replace(/&quot;/g, '"').replace(/&amp;/g, "&")); } catch (e) {}
    var selected = [];
    $$("[data-opt-group]", buy).forEach(function (g, i) {
      var active = g.querySelector(".is-active"); selected[i] = active ? active.getAttribute("data-opt-name") : null;
    });
    function findVariant() {
      return variants.find(function (v) { return v.options.every(function (o, i) { return selected[i] == null || o === selected[i]; }); });
    }
    function updateBuy() {
      var v = findVariant(); if (!v) return;
      var priceEl = $("[data-price]", buy), cmp = $("[data-compare]", buy), save = $("[data-save]", buy);
      if (priceEl) priceEl.textContent = money(v.price);
      var mirror = $("[data-price-mirror]"); if (mirror) mirror.textContent = money(v.price);
      if (cmp) { if (v.compare_at_price && v.compare_at_price > v.price) { cmp.style.display = ""; cmp.textContent = money(v.compare_at_price); if (save) { save.style.display = ""; save.textContent = T('save','Save ') + money(v.compare_at_price - v.price); } } else { cmp.style.display = "none"; if (save) save.style.display = "none"; } }
      var stock = $("[data-stock]"), stxt = $("[data-stock-text]");
      $$("[data-add-to-cart]").forEach(function (b) {
        b.setAttribute("data-variant-id", v.id);
        if (v.available) { b.disabled = false; b.textContent = T('add_to_cart','Add to cart'); } else { b.disabled = true; b.textContent = T('sold_out','Sold out'); }
      });
      if (stock) stock.classList.toggle("is-out", !v.available);
      if (stxt) stxt.textContent = v.available ? T('in_stock','In stock · ships in 24–48h') : T('out_of_stock','Out of stock');
      if (v.featured_image && v.featured_image.src) { var m = $("[data-gallery-main]"); if (m) m.src = v.featured_image.src; }
    }
    $$("[data-opt-btn]", buy).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.getAttribute("data-opt-index"), 10);
        selected[idx] = btn.getAttribute("data-opt-name");
        var group = btn.parentNode;
        $$("[data-opt-btn]", group).forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        var lbl = $('[data-opt-value="' + idx + '"]'); if (lbl) lbl.textContent = selected[idx];
        SFX.play("tick"); updateBuy();
      });
    });
  }

  /* ---------------- Accordions ---------------- */
  $$("[data-acc]").forEach(function (h) {
    h.addEventListener("click", function () { h.closest(".pdp-acc").classList.toggle("is-open"); });
  });

  /* ---------------- Cart page qty ---------------- */
  $$("[data-cartpage-items] [data-line-key]").forEach(function () {});

  /* ---------------- Gallery thumbs ---------------- */
  $$("[data-gallery-thumb]").forEach(function (t) {
    t.addEventListener("click", function () {
      var full = t.getAttribute("data-full"), main = $("[data-gallery-main]");
      if (main && full) main.src = full;
      $$("[data-gallery-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
      t.classList.add("is-active");
    });
  });

  // initial sync
  refresh();
})();
